// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectBasicStylized_root___edkm"};